import React, { createContext, useContext, useMemo } from "react"

export interface FormContextValue {
  isReadonly?: boolean
  isDisabled?: boolean
}

export const FormContext = createContext<FormContextValue>({
  isReadonly: undefined,
  isDisabled: undefined
})

export interface FormProviderProps extends FormContextValue {
  children: React.ReactNode
}

export const FormProvider = React.memo(
  ({ isReadonly, isDisabled, children }: FormProviderProps) => {
    const memoizedValue = useMemo(
      () => ({ isReadonly, isDisabled }),
      [isReadonly, isDisabled]
    )

    return (
      <FormContext.Provider value={memoizedValue}>
        {children}
      </FormContext.Provider>
    )
  }
)

FormProvider.displayName = "FormProvider"

export function useOptionalFormContext(): FormContextValue | undefined {
  return useContext(FormContext)
}
